export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-05.jpg'),
        title: 'ビッグデータ',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'データはかつてないほど私たちの生活の隅々に根付いています',
      description: `<p style="font-size:1.05rem">今日、データは私たちの生活のあらゆる場面に深く浸透しており、問題解決や福利の改善、新たな経済繁栄の創出に活用されています。データ処理能力の向上、計算・保存コストの低下、そしてセンサ搭載デバイスの増加により、データの収集・保存・分析は急速に増大しています。技術の成熟に伴い、デバイス、交通機関、ウェアラブル技術が相互接続され、より多くの価値が生み出されます。</p>
      <p>
    私たちの技術: 大規模データ収集—分散かつ高速で信頼性のあるデータ収集技術により、データの抽出・変換・ロードを行い、潜在的価値を発掘します。<br/>
    大データ前処理—データマイニング前に、データクレンジング、データ統合、変換、削減等を実施し、解析品質を高め処理時間を短縮します。<br/>
    大規模データの管理・保管—Hadoopなどの分散格納技術を用いて保存と管理能力を向上させます。<br/>
    大データ解析・マイニング—オフライン解析、準リアルタイム解析、リアルタイム解析、画像認識、音声認識、機械学習などを活用します。主な技術例：MapReduce、Hive、Pig、Spark、Flink、Impala、Kylin、Tez、Akka、Storm、S4、Mahout、MLlib。<br/>
    大データの可視化と応用
    </p>`
    },
    {
      title: '当社のサービス',
      description:`<span class='img' style="background:url(`+require('../../../assets/images/services/pic-05.jpg')+`)"></span>
      <span class="list">
      <i></i>ワンストップ開発<br/>
      <i></i>オープンで柔軟<br/>
      <i></i>成熟かつ安定<br/>
      <i></i>安全で信頼性が高い<br/>
      <i></i>高品質なサービス
      </span>`
    }
  ]
}
